import { useFormik } from 'formik';
import { initialValues } from './formData';
import { cleanObj } from '../../../../../shared/utils/objects';
import { ISelect, ParamEnum } from '../../../../../shared/types/shared';
import { useEffect, useState } from 'react';
import { asyncGetParams } from '../../../../../services/param.service';
import { useParams } from 'react-router-dom';
import { SarlaftFilter } from '../../../../../shared/types/modules/sarlaft';

export const useSarlaftFilters = (onFilter?: (data: SarlaftFilter) => void) => {
    const { sarlaftId } = useParams();
    const [status, setStatus] = useState<ISelect[]>([]);
    const [casesStatus, setCasesStatus] = useState<ISelect[]>([]);

    const onSubmit = (data: SarlaftFilter) => {
        if (onFilter) onFilter(cleanObj(data) || {});
    };

    const formik = useFormik({
        initialValues: {
            ...initialValues,
            sarlaftId: sarlaftId?.trim() || '',
        },
        onSubmit,
    });

    useEffect(() => {
        if (
            formik?.values?.sarlaftId &&
            formik?.values?.sarlaftId === sarlaftId?.trim()
        ) {
            formik?.submitForm();
        }
    }, [sarlaftId, formik?.values?.sarlaftId]);

    useEffect(() => {
        asyncGetParams(ParamEnum.SARLAFT_STATUS_VALIDATION).then((params) =>
            setStatus(params)
        );
    }, []);

    useEffect(() => {
        asyncGetParams(ParamEnum.SARLAFT_STATUS).then((items) =>
            setCasesStatus(items)
        );
    }, []);

    return {
        formik,
        status,
        casesStatus,
    };
};
